import Axios from 'axios';

const checkText = async (text, enableHiddenRules = null, level = 'default', disabledCategories = null) => {
	try {
		const payload = { text };

		if (enableHiddenRules) payload.enableHiddenRules = enableHiddenRules;
		if (level) payload.level = level;
		if (disabledCategories) payload.disabledCategories = disabledCategories;

		const res = await Axios.post('/api/language-tool/check', payload);
		return res.data.data;
	} catch (error) {
		console.error(error);
		return { matches: [] };
	}
};

export default { checkText };
